import React from 'react';
import { HiOutlineGlobeAlt } from 'react-icons/hi';

/**
 * GlobeIcon
 * Ikona zemegule pre označenie webových adries alebo globálnych údajov.
 */
const GlobeIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <HiOutlineGlobeAlt className={className} {...props} />
);

export default GlobeIcon;

